import React from 'react';
import { Dialog, DialogContent, DialogActions, Typography, Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Confetti from 'react-confetti';

/**
 * Online equivalent of GameWinnerModal.jsx — same fullscreen confetti
 * celebration for winning the whole MATCH (matchScore reaching gamePoints),
 * simplified: no share-image/in-app-review integrations (those are
 * device-specific offline features, out of scope here), just the winner
 * display and a way back to the lobby.
 */
export default function MatchWinnerModal({ open, winnerTeamId, playersBySeat, onBackToLobby }) {
    const { t } = useTranslation();
    const winningSeats = winnerTeamId === 1 ? [0, 2] : [1, 3];

    return (
        <Dialog
            open={open}
            fullScreen
            PaperProps={{
                style: { backgroundColor: 'rgba(0, 0, 0, 0.9)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' },
            }}
        >
            {open && <Confetti recycle numberOfPieces={200} />}

            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1.5, padding: '16px !important' }}>
                <Typography variant="h3" sx={{ color: '#FFD700', fontWeight: 'bold', textShadow: '0 0 20px rgba(255, 215, 0, 0.5)', fontSize: { xs: '2rem', sm: '2.5rem' } }}>
                    {t('online.play.match_over.title', { teamId: winnerTeamId })}
                </Typography>

                <Box sx={{ display: 'flex', gap: 3, mt: 1 }}>
                    {winningSeats.map((seat) => {
                        const player = playersBySeat?.[seat];
                        if (!player) return null;
                        return (
                            <Box key={seat} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Box
                                    sx={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: '50%',
                                        border: '3px solid #FFD700',
                                        boxShadow: '0 0 15px rgba(255, 215, 0, 0.5)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '2.5rem',
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    }}
                                >
                                    {player.avatar || (player.isSystem ? '🤖' : '🙂')}
                                </Box>
                                <Typography variant="body1" sx={{ color: 'white', mt: 0.5, fontWeight: 'bold' }}>
                                    {player.name}
                                </Typography>
                            </Box>
                        );
                    })}
                </Box>
            </DialogContent>

            <DialogActions sx={{ pb: 3, pt: 0 }}>
                <Button
                    variant="contained"
                    size="large"
                    onClick={onBackToLobby}
                    sx={{
                        backgroundColor: '#FFD700',
                        color: 'black',
                        fontWeight: 'bold',
                        fontSize: '1.1rem',
                        padding: '10px 40px',
                        borderRadius: '50px',
                        minWidth: '220px',
                        '&:hover': { backgroundColor: '#FFC107' },
                    }}
                >
                    {t('common.home')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
